
import React from 'react';
import ZProps from "./zprops";
import ZLog from "./zlog";
import ZNetwork from "./znetwork";
import ZUtil from "./zutil";
import {ROUTER} from "./AMCRouter";
import {ZooSearchBar} from "./ZooProfilePage";
import AMC from "./AMC";
import PleaseStandBy from "./PleaseStandBy";
import { KINDS } from './AMCConstants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCodeBranch, faStar, faCog, faThumbsUp, faPuzzlePiece, faList, faSearch } from '@fortawesome/free-solid-svg-icons'

export default class RockWorkspace extends React.Component {
	constructor(props) {
		super(props);
		this.state = JSON.parse(ZUtil.getCandy("RockWorkspace") || "{}");
	}
	componentDidMount() {
		this.setView(this.state.view || this.props.view || "runs");
	}
	setView = (view) => {
		let { selected_item } = this.props;
		let user = ZProps.get("user");
		let keywords = this.state.keywords;
		// just flashes wait icon a 1/2 sec this.setState({ loading: true });
		switch (view) {
			case "versions" :
				ZNetwork.get("versions", selected_item.uri.split(":")[0], (err, things) => {
					this.setState({ list: (things || []).filter( t => t.kind === "service" ), loading: false });
				});
				break;
			case "likes" :
				ZNetwork.get("relations", "like", user.uri, (err, liked_things) => {
					this.setState({ list: (liked_things || []).filter( t => t.kind === "service" ), loading: false });
				});
				break;
			case "stars" :
				ZNetwork.get("relations", "star", user.uri, (err, starred_things) => {
					this.setState({ list: (starred_things || []).filter( t => t.kind === "service" ), loading: false });
				});
				break;
			case "group" :
				ZNetwork.post("things", { options: { group: user.group, version: 0 } }, (err, things) => {
				// ZNetwork.get("things", user.group, (err, things) => {
					this.setState({ list: (things || []).filter( t => t.kind === "service" ), loading: false });
				});
				break;
			case "search" :
				if (keywords && keywords.trim().length > 0) {
					ZNetwork.get("search", keywords, (err, list) => {
						list = (list && Object.keys(list).reduce( (results, kind) => results.concat(list[kind]), [] )) || [];
						list = list.filter( t => t.kind !== "user" );
						this.setState({ list: list, loading: false });
					});
				}
				break;
			case "settings" :
				this.setState({ list: [ZProps.get("wtf"), ZProps.get("freakout"), ZProps.get("helpmechoose"), ZProps.get("rockpile"), ZProps.get("themes")], loading: false });
				break;
			default :
				ZLog.error("RockWorkspace.setView - Unknown view: " + view);
				this.setState({ loading: false });
				break;
		}
		this.setState({ view: view });
		this._updateCandies({ view: view });
	}
	selectItem = (item) => {
		let { onWorkspaceItemSelect } = this.props;
//		this.setState({ selected: item.uri });
//		this._updateCandies({ selected: item.uri });
		ROUTER.softPushRoute("/zoo/" + item.uri);
		onWorkspaceItemSelect(item);
	}
	onSearch = (keywords) => {
		this.setState({ keywords: keywords });
		this._updateCandies({ keywords: keywords });
		setTimeout(() => {
			this.setView("search", keywords);
		}, 10);
	}
	_updateCandies(props) {
		let candies = JSON.parse(ZUtil.getCandy("RockWorkspace") || "{}");
		ZUtil.setCandy("RockWorkspace", JSON.stringify(Object.assign(candies, props)));
	}
	render() {
		let { inspector_open, toggleInspector, selected_item } = this.props;
		let { list, view, keywords, loading } = this.state;

console.log("loading=" + loading);
console.log("list=" + list);
console.log("view=" + view);
		list = list || [];
		let groupthumb = AMC.getUserOrGroupThumbElement(ZProps.get("user").group);
		let PALETTE = [
			{ which: "group", label: "my stuff", icon: null, img: groupthumb, empty: "You haven't created anything yet" },
			{ which: "stars", label: "starred", icon: faStar, empty: "You haven't starred anything yet" },
			{ which: "likes", label: "liked", icon: faThumbsUp, empty: "You haven't liked anything yet" },
			{ which: "versions", label: "versions", icon: faCodeBranch },
			{ which: "settings", label: "settings", icon: faCog },
			{ which: "search", label: "search", icon: faSearch, empty: "Search results" },
		]
		let palette = PALETTE.map( icon => {
			return <div key={icon.which} className={"RockWorkspaceIcon" + (view === icon.which ? " RockWorkspaceIconSelected" : "")} onClick={e => this.setView(icon.which)} title={icon.label}>{ icon.icon ? <FontAwesomeIcon icon={icon.icon} /> : icon.img }</div>
		});
		palette.push( <div key="inspect" className={"RockWorkspaceInspectorIcon" + (inspector_open ? " RockWorkspaceIconSelected" : "")} onClick={toggleInspector} title="Inspector"><FontAwesomeIcon icon={faList} /></div> );

		let payload = list.length === 0 ? <h1 className="CENTEREDPART">{PALETTE.filter( icon => icon.which === view )[0].empty}</h1> : list.map( item => {
			return <RockWorkspaceRow key={item.uri} item={item} selectItem={this.selectItem} selected={selected_item && item.uri === selected_item.uri} />
		})
		let search = view === "search" ? <ZooSearchBar onSearch={this.onSearch} placeholder="e.g. is:service keras" value={keywords} /> : '';
		return (
			<div className={"RockWorkspace" + (view === "search" ? " RockWorkspaceSearch" : "")} style={inspector_open ? {width: "50%"} : null} >
				<div className="RockWorkspacePalette">
					{palette}
				</div>
				<div className="RockWorkspacePayload">
					{payload}
				</div>
				{search}
				{ loading ? <PleaseStandBy /> : '' }
			</div>
		);
	}
}
class RockWorkspaceRow extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	render() {
		let { item, selected } = this.props;
		let thumb = null;
		if (KINDS[item.kind]) {
			thumb = <FontAwesomeIcon icon={KINDS[item.kind].icon} />
		} else {
			thumb = <FontAwesomeIcon icon={faPuzzlePiece} />
		}
ZLog.log("RockWorkspaceRow item=", item);
ZLog.log("RockWorkspaceRow item.group=", item.group);
		let ownerthumb = AMC.getUserOrGroupThumbElement(item.group);
		let type = item.kind === "service" ? item : ((item.type && ZProps.get(item.type)) || {});

// RockWorkspaceRow
//RockWorkspaceRow
		return (
			<div id={"RockWorkspaceRow" + item.uri} className={"RockWorkspaceRow" + (selected ? " RockWorkspaceRowSelected" : "")} onClick={e => this.props.selectItem(item) } >
				<span className="RockWorkspaceRowKindThumb">{thumb}</span>
				<span className="RockWorkspaceRowOwnerThumb">{ownerthumb}</span>
				<span title={item.uri} className="RockWorkspaceRowName">{item.name}</span>
				<span title="version" className="RockWorkspaceRowVersion">{item.version ? "v." + item.version : ""}</span>
				<span className="RockWorkspaceRowKind">{item.kind}</span>
				<span className="RockWorkspaceRowOwner">{type.owner || item.group}</span>
				{ item.kind === "service" ?
					<span className="RockWorkspaceRowState">{item.state}</span>
				: '' }
				{ item.kind === "service" && item.stats ?
					<span className="RockWorkspaceRowAccuracy">{item.stats.accuracy && (ZUtil.toShortNumber(item.stats.accuracy) + "%")}</span>
				: '' }
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/RockWorkspace.js